<template>
  <div>
    <b-modal
      centered
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      v-model="showModal"
      @close="closeModal"
      class="pa-4"
      :style="'width: 708px !important;'"
      id="reqsFilterModal"
    >
      <template #modal-title>
        <h3 class="font-weight-bold">Filter</h3>
      </template>
      <b-card no-body v-cloak class="rounded-0 border-0 mx-0 bg-light">
        <form @submit.prevent="submitFilter">
          <b-card-text :style="'opacity: 1;'">
            <b-container>
              <b-row>
                <b-col cols="12">
                  <h6 class="font-weight-bold">
                    Owned By
                  </h6>
                  <div class="search">
                    <b-icon scale="1" icon="search" class="fa fa-search" />
                    <b-form-input v-model="form.ownedBy" />
                  </div>
                </b-col>
                <b-col cols="12">
                  <h6 class="font-weight-bold">
                    Status
                  </h6>
                  <b-form-group v-slot="{ ariaDescribedby }">
                    <b-form-checkbox-group
                      stacked
                      v-model="form.status"
                      :options="statuses"
                      :aria-describedby="ariaDescribedby"
                    ></b-form-checkbox-group>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-container>
          </b-card-text>

          <div class="my-4 mx-0">
            <b-container>
              <b-row align-v="center">
                <b-col cols="12" md="5" class="mb-md-4 mb-3">
                  <b-button
                    class="w-100 btn-outlined bg-white text-dark"
                    variant="outline-secondary"
                    :style="'height: 64px !important;'"
                    :disabled="loading"
                    @click="clear"
                  >
                    Clear
                  </b-button>
                </b-col>
                <b-col cols="12" md="2" class="mb-0"></b-col>
                <b-col cols="12" md="5" class="mb-md-4 mb-3">
                  <b-button
                    type="submit"
                    class="w-100 h-auto float-right py-3"
                    variant="primary"
                    :style="'height: 64px !important;'"
                    :loading="loading"
                    :disabled="loading"
                  >
                    Save
                  </b-button>
                </b-col>
              </b-row>
            </b-container>
          </div>
        </form>
      </b-card>
    </b-modal>
  </div>
</template>

<script>
import Form from '@/utils/form'

export default {
  name: 'ReqsFilterModal',

  props: {
    showRequestsFilter: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false,
      form: new Form({
        ownedBy: '',
        status: []
      }),
      statuses: [
        { text: 'Rejected', value: 'rejected' },
        { text: 'Pending Approval', value: 'pending approval' },
        { text: 'Not Started', value: 'not started' }
      ]
    }
  },

  computed: {
    showModal: {
      get() {
        return this.showRequestsFilter
      },
      set() {
        this.$emit('closeRequestsFilterModal')
      }
    }
  },

  methods: {
    clear() {
      this.form.ownedBy = ''
      this.form.status = []
    },

    submitFilter() {
      this.$root.$emit('submitRequestsFilters', this.form)
      this.closeModal()
    },

    closeModal() {
      this.clear()
      this.showModal = false
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .b-form-btn-label-control.form-control {
  label {
    min-height: calc(2.3rem - 2px) !important;
  }
}

/deep/ .search {
  position: relative;
  color: #aaa;
  font-size: 16px;
}

/deep/ .search input {
  text-indent: 32px;
}

/deep/ .search .fa-search {
  position: absolute;
  top: 16px;
  left: 16px;
}
</style>
